import React, { useEffect, useState } from 'react'
import './topbar.css'
import defaultImage from '../Images/def.png'
import { app } from "../firebase.js"
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import logo from '../Images/newlogo.svg'

function Topbar() {

  const auth = getAuth()
  const db = getFirestore(app)
  const navigate = useNavigate()

  const [username, setUsername] = useState("Hey Stanger")
  const [profileImage, setProfileImage] = useState(defaultImage)

  useEffect(() => {
    const cached = JSON.parse(localStorage.getItem("profileData") || "{}")

    if (cached.userName) setUsername(cached.userName)
    if (cached.profileImage) setProfileImage(cached.profileImage)

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        console.log("hello stranger")
        return
      }

      const uid = user.uid
      const docRef = doc(db, "users", uid)
      const snap = await getDoc(docRef)

      if (snap.exists()) {
        const data = snap.data()

        const freshName = data.userName || ""
        
        const freshImage = data.profileImage || defaultImage

        const changedName = cached.userName !== freshName
        const changedImage = cached.profileImage !== freshImage

        if (changedName) setUsername(freshName)
        if (changedImage) setProfileImage(freshImage)

        if (changedName || changedImage) {
          const updated = { 
            ...cached, 
            userName: freshName, 
            profileImage: freshImage 
          }
          localStorage.setItem("profileData", JSON.stringify(updated))
        }
      }
    })

    return () => unsubscribe()
  }, [])

  return (
    <div className='topbar'>
      <img src={logo} className="topbarLogo" />

      <div className='topbarNewCont'>
        <h6>{username}</h6>
        <div className='topBarProfileImageCont'>
          <img src={profileImage} alt="" />
        </div>
      </div>
    </div>
  )
}

export default Topbar